import React from "react";
import { FormHandles } from "@unform/core";

export const reduceFormErrors = (
  formRef: React.RefObject<FormHandles>,
  newErrors: {
    [x: string]: string | undefined;
  } = {}
): {
  [x: string]: string;
} => {
  const oldErrors = formRef.current?.getErrors() || {};
  const concatErrors = { ...oldErrors, ...newErrors };
  const reducedErrors: {
    [x: string]: string;
  } = {};

  for (const key in concatErrors) {
    const value = concatErrors[key];
    if (key && value !== undefined) {
      reducedErrors[key] = value;
    }
  }

  return reducedErrors;
};
